import { Grid, Icon, LinearProgress, makeStyles, Tooltip } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import { OnboardingContext } from 'app/main/onboarding/OnboardingContext';
import { excluirAlert } from 'app/services/alerts';
import { parametrosNotaFiscalApi } from 'app/services/api/parametrosNotaFiscalApi';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import { useFormikContext } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: 'center',
    height: '250px',
    backgroundColor: '#f5f5f5',
  },
  icon: {
    fontSize: '7.6rem',
    color: '#2e62b8',
    marginTop: '5%',
  },
  content: {
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'left',
    color: '#464646',
  },
  formatosPermitidos: {
    fontSize: '12px',
    lineHeight: 1.29,
    color: '#65666f',
  },
  imagem: {
    marginTop: '3%',
    marginBottom: '1%',
    width: '80px',
    height: '80px',
  },
  MuiLinearProgressRoot: {
    height: '8px',
    borderRadius: '8px',
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#2e62b8',
    },
  },
  check: {
    color: '#27ae60',
    fontSize: '16px',
    marginLeft: '6px',
  },
}));

const UploadCertificado = () => {
  const classes = useStyles(useStyles);
  const formikContext = useFormikContext();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [, setFileSize] = useState();
  const [parametrosNotaFiscal, setParametrosNotaFiscal] = useContext(OnboardingContext).parametrosNotaFiscal;
  const [uploadConcluido, setUploadConcluido] = useState(false);
  const [uploading, setUploading] = useContext(OnboardingContext).uploading;
  const [, setLoading] = useContext(OnboardingContext).loading;

  const dispatch = useDispatch();

  const showError = (message) => {
    dispatch(MessageActions.showMessage({ message, variant: 'error' }));
  };

  const showSucess = (message) => {
    dispatch(MessageActions.showMessage({ message, variant: 'success' }));
  };

  const formikContextCertificadoSelecionado = formikContext.values?.certificadoSelecionado;
  useEffect(() => {
    setLoading(true);
    /*   if (!formikContext.values?.certificado) {
      formikContext.handleChange({
        target: { id: 'certificado', value: formikContextCertificadoSelecionado },
      });
    } */
    if (formikContextCertificadoSelecionado?.nome) {
      const certificado = {
        id: formikContextCertificadoSelecionado?.id,
        name: formikContextCertificadoSelecionado?.nome,
      };
      setFileName(formikContextCertificadoSelecionado?.nome);
      setFileSize(formikContextCertificadoSelecionado?.size);
      setFile(certificado);

      setUploadConcluido(true);
      setLoading(false);
    }

    setLoading(false);
  }, [formikContextCertificadoSelecionado, setLoading]);

  const handleChange = async (arquivo) => {
    if (arquivo.size > 5242880) {
      showError('É permitido anexar apenas 1 arquivo de no máximo 5MB');
      return;
    }

    const lastDot = arquivo.name.lastIndexOf('.');
    const ext = arquivo.name.substring(lastDot + 1).toLowerCase();

    if (ext !== 'pfx' && ext !== 'p12') {
      showError('É permitido anexar somente arquivo nos formatos: PFX e P12.');
      return;
    }

    setUploading(true);
    setFile(arquivo);
    setFileName(arquivo.name);
    setFileSize(arquivo.size);

    const certificado = Object.assign(arquivo, {
      id: undefined,
      nome: arquivo.name,
      contentType: arquivo.type,
    });

    const formData = new FormData();
    formData.append('certificado', certificado);

    const res = await parametrosNotaFiscalApi().uploadCertificado(formData);

    formikContext.handleChange({ target: { id: 'certificadoSelecionado.id', value: res.data?.id } });
    formikContext.handleChange({ target: { id: 'certificadoSelecionado.contentType', value: res.data?.contentType } });
    formikContext.handleChange({ target: { id: 'certificadoSelecionado.nome', value: res.data?.nome } });

    formikContext.handleChange({ target: { id: 'certificado.id', value: res.data?.id } });
    formikContext.handleChange({ target: { id: 'certificado.contentType', value: res.data?.contentType } });
    formikContext.handleChange({ target: { id: 'certificado.nome', value: res.data?.nome } });

    parametrosNotaFiscal.certificado = { ...res.data };
    setParametrosNotaFiscal(parametrosNotaFiscal);

    setUploadConcluido(true);
    setUploading(false);
  };

  const handleUploadArquivo = () => {
    excluirAlert({
      confirmar: async () => {
        try {
          setLoading(true);
          await parametrosNotaFiscalApi().removerCertificado({
            certificado: parametrosNotaFiscal.certificado,
          });
          parametrosNotaFiscal.certificado = null;
          setParametrosNotaFiscal(parametrosNotaFiscal);
          formikContext.resetForm({
            id: parametrosNotaFiscal?.id,
          });
          setFile(null);
          setLoading(false);
          showSucess('Certificado digital excluído com sucesso.');
        } catch {
        } finally {
          setLoading(false);
        }
      },
      opcoes: {
        title: 'Você realmente deseja excluir?',
        text: '',
      },
    });
  };

  const exibeAreaPreUpload = () => {
    return (
      <Tooltip title={'Adicionar certificado'} placement="bottom">
        <span>
          <FileUploader
            multiple={false}
            className="hidden"
            handleChange={handleChange}
            name="file"
            label=""
            hoverTitle=" "
          >
            <label
              htmlFor="button-file"
              className={
                'flex items-center justify-center relative rounded-4 mx-8 mb-16 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
              }
            >
              <Grid container className={classes.container}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Icon className={classes.icon} color="action">
                    cloud_upload
                  </Icon>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <span className={classes.content}>
                    Arraste o arquivo do seu certificado digital para configurá-lo.
                  </span>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: '5%' }}>
                  <span className={classes.formatosPermitidos}>Formatos permitidos: PXF e P12.</span>
                </Grid>
              </Grid>
            </label>
          </FileUploader>
          {(formikContext.submitCount > 0 || formikContext.touched?.certificado) &&
          formikContext.errors?.certificado ? (
            <label className="MuiFormHelperText-root Mui-error" style={{ color: 'red' }}>
              {formikContext.errors.certificado}
            </label>
          ) : null}
        </span>
      </Tooltip>
    );
  };

  const exbibeAreaPosUpload = () => {
    return (
      <label
        htmlFor="button-file"
        className={
          'flex items-center justify-center relative rounded-4 mx-8 mb-16 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
        }
      >
        <Grid container className={classes.container}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {file && (
              <center>
                <Icon className={classes.icon} style={{ color: '#b9bec7' }}>
                  description
                </Icon>
              </center>
            )}
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'left' }}>
            <span className={classes.content}>{fileName}</span>
            <CheckCircle className={classes.check} />
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={1} style={{ textAlign: 'left' }}></Grid>
          <Grid item lg={1} md={1} sm={1} xs={1} style={{ textAlign: 'right' }}>
            <button title="Excluir imagem adicionada" onClick={handleUploadArquivo}>
              x
            </button>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={8} md={8} sm={8} xs={8}>
            {uploading ? (
              <LinearProgress className={classes.MuiLinearProgressRoot} />
            ) : uploadConcluido ? (
              <LinearProgress className={classes.MuiLinearProgressRoot} variant="determinate" value={100} />
            ) : null}
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={8} md={8} sm={8} xs={8} />
          <Grid item lg={2} md={2} sm={2} xs={2} style={{ textAlign: 'right', fontSize: '14px', marginBottom: '5%' }}>
            {uploadConcluido ? <label>100%</label> : null}
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
        </Grid>
      </label>
    );
  };

  return <>{!file ? exibeAreaPreUpload() : exbibeAreaPosUpload()}</>;
};

export default UploadCertificado;
